import React, { useState } from "react";
import { Link } from "react-router-dom";
import UserAvatar from "../../../images/user.png";
import {
  BASE_URL_MEDIA,
  BASE_URL_COMPETITION,
  IS_CORPORATE,
  BASE_URL_METABUDDY,
} from "../../../api/Constants";
import UserDropdownMenu from "./UserDropdownMenu";
import { getImageUrl } from 'components/helpers/Helpers';

/**
 * Desktop Navigation Component
 * Renders the navigation menu for desktop viewports
 */
const DesktopNav = ({
  menuItems,
  activePage,
  metaToken,
  userProfile,
  userEmail,
  showUserMenu,
  toggleUserMenu,
  LogOut,
  checkCurrentPageUrl,
  logo,
}) => {
  // State for tracking which desktop submenu is hovered
  const [hoveredItem, setHoveredItem] = useState(null);

  return (
    <div className="navbar desktop-only">
      {/* Logo */}
      <div className="logo">
        <a href={IS_CORPORATE ? BASE_URL_COMPETITION : BASE_URL_METABUDDY}>
          <img src={logo} alt="Logo" />
        </a>
      </div>

      {/* Desktop navigation */}
      <div className="desktop-nav">
        <ul>
          {menuItems.map((item, index) => {
            // Check if item has submenu
            const hasSubmenu = item.submenu && item.submenu.length > 0;

            return (
              <li
                key={`desktop-${index}`}
                className={`${activePage === item.path ? "active-page" : ""} ${
                  hasSubmenu ? "has-submenu" : ""
                }`}
                onMouseEnter={() => hasSubmenu && setHoveredItem(index)}
                onMouseLeave={() => setHoveredItem(null)}
              >
                {item.isExternal ? (
                  <a href={item.path}>
                    {item.label}
                    {hasSubmenu && (
                      <span className="desktop-dropdown-arrow"></span>
                    )}
                  </a>
                ) : (
                  <Link to={item.path}>
                    {item.label}
                    {hasSubmenu && (
                      <span className="desktop-dropdown-arrow"></span>
                    )}
                  </Link>
                )}

                {/* Submenu items if available */}
                {hasSubmenu && hoveredItem === index && (
                  <ul className="desktop-submenu">
                    {item.submenu.map((subItem, subIndex) => (
                      <li key={`desktop-submenu-${index}-${subIndex}`}>
                        {subItem.isExternal ? (
                          <a href={subItem.path}>{subItem.label}</a>
                        ) : (
                          <Link to={subItem.path}>{subItem.label}</Link>
                        )}
                      </li>
                    ))}
                  </ul>
                )}
              </li>
            );
          })}
        </ul>
      </div>

      {/* User Profile or Login/Register */}
      <div className="auth-section">
        {metaToken ? (
          <div className="user-profile-area">
            <div className="nav-user-avatar" onClick={toggleUserMenu}>
              {userProfile ? (
                <img
                src={
                  !userProfile || userProfile === 'null'
                    ? `${UserAvatar}`
                    : getImageUrl(userProfile, BASE_URL_MEDIA)
                }
                  alt=""
                />
              ) : (
                <img src={UserAvatar} alt="" />
              )}
              
              <span className="user-email">{userEmail}</span>
              <span
                className={`dropdown-arrow ${showUserMenu ? "active" : ""}`}
              ></span>

              {showUserMenu && (
                <UserDropdownMenu
                  toggleUserMenu={toggleUserMenu}
                  LogOut={LogOut}
                  checkCurrentPageUrl={checkCurrentPageUrl}
                />
              )}
            </div>
          </div>
        ) : (
          <div className="login-register-links">
            <Link to="/login" onClick={() => checkCurrentPageUrl()}>
              Login
            </Link>
            <Link to="/register" onClick={() => checkCurrentPageUrl()}>
              Register
            </Link>
          </div>
        )}
      </div>
    </div>
  );
};

export default DesktopNav;
